import { LoadingSpinner } from "@app/form_components";
import BaseDialog from "./BaseDialog";
import CommonModuleInstallOptions from "../CommonModuleInstallOptions";

export default class CommonModuleChangeVersionDialog extends BaseDialog {
    /**
     * Dialog for adding a new prompt for dialog editor
     * @module CommonModuleChangeVersionDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        
        this.downloadHandle = this.handleDownload.bind(this);
        this.installOptionsHandle = this.handleInstallOptionsHandle.bind(this);
        this.installOptionsChangeConfigHandle = this.handleOnInstallOptionsChangeConfig.bind(this);

        this.state = {
            isDownloading : false,
            showInstallOptions: false,
            commonModule: null,
            previousCommonModule: null,
            installOptionsConfig: null,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-download-common-module", this.downloadHandle);
        document.addEventListener("ev-dialog-show-common-module-install-options", this.installOptionsHandle);
    }

    unregister() {
        document.removeEventListener("ev-dialog-download-common-module", this.downloadHandle);
        document.removeEventListener("ev-dialog-show-common-module-install-options", this.installOptionsHandle);
    }

    handleInstallOptionsHandle(event){
        const {commonModule, previousCommonModule} = event.detail;
        this.setState({isDownloading: false});
        this.setState({showInstallOptions: true});
        this.setState({commonModule: commonModule});
        this.setState({previousCommonModule: previousCommonModule});
        $(".w2ui-popup").css( "width", "+=155");
        
    }
    
    async handleDownload(){
        if(this.state.showInstallOptions){
            let commonModule = this.state.commonModule;
            const previousCommonModule = this.state.previousCommonModule;
            const disableRedaction = this.state.installOptionsConfig?.redactSensitive;
            
            await window.apm.commonModuleManager.changeCommonModuleVersion(commonModule, previousCommonModule, disableRedaction);
            document.dispatchEvent(new CustomEvent('ev-dialog-close'));
            w2popup.close();
        } else {
            const { selectedVersion, node } = this.props;
            const { repoName } = window.apm.serialized.components.modules.find(mod => mod.id === node.id);
            const { id, name } = node;

            this.setState({ isDownloading: true });
            window.apm.postEventToCurrentView({ target: "request-hide-property-panel" });
            window.apm.commonModuleManager.initializeChangeVersion(
                repoName,
                selectedVersion,
                name,
                id
            );
        }
    }

    /**
     * Handle changes on InstallOptions component
    */
    handleOnInstallOptionsChangeConfig(key, value){
        this.setState({commonModule: {...this.state.commonModule, sensitiveOverrides: {...this.state.commonModule?.sensitiveOverrides, enabled: !value}}});
        this.setState({installOptionsConfig: {[key]: value}});
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const replaceMessage = `This will replace version ${this.props.currentVersion} with version ${this.props.selectedVersion}`;
        const promptMessage = `All local prompt and module input changes will be preserved`;

        return (
            <div>
                <div className={"container-fluid element-dialog element-body"} style={{overflow: 'hidden', bottom:'0px', paddingTop: 'calc(var(--space) * 2)'}}>
                    <div className={"row"}>
                        <div className="col-md-12" style={{ textAlign: 'center' }}>
                            {!this.state.isDownloading && !this.state.showInstallOptions && (
                                <>
                                    <div style={{ textAlign: 'center', marginBottom: 'var(--space)' }}><strong>{this.props.name}</strong></div>
                                    <p>{replaceMessage}</p>
                                    <p>{promptMessage}</p>
                                    <p>Do you wish to continue?</p>
                                </>
                            )}
                            {this.state.showInstallOptions && (
                                <div style={{ paddingTop: "74px" }}>
                                    <CommonModuleInstallOptions
                                        commonModule={this.state.commonModule}
                                        previousCommonModule={this.state.previousCommonModule}
                                        type="versionChange"
                                        handleOnChangeConfig={this.installOptionsChangeConfigHandle}
                                    />
                                </div>
                            )}
                            {this.state.isDownloading && (
                                <div>
                                    <LoadingSpinner message={'Installing version ' + this.props.selectedVersion} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}